export default "__VITE_ASSET__f2653854__"